export default __webpack_public_path__ + "static/media/x.020171ac.svg";